import { AdvisorsPaths } from '@src/components/sco/Advisors/paths'
import { IconType } from 'react-icons'
import { LuBriefcase, LuGauge, LuMailOpen, LuSend, LuTarget } from 'react-icons/lu'

export type OpportunitiesSectionKey = 'overview' | 'invites' | 'applications' | 'matches' | 'engagements'

export type OpportunitiesNavItem = {
  key: OpportunitiesSectionKey
  title: string
  /** One-line description shown on the overview cards. */
  description: string
  href: string
  icon: IconType
  /** Which count feeds this item's badge; overview has none. */
  countKey?: 'invited' | 'applied' | 'matched' | 'active'
  /** Palette for the count badge when non-zero. */
  palette?: string
}

/**
 * Opportunities sub-sections, in rail order.
 *
 * Built from `paths` so the Request Workspace embed
 * (`/requests/manage/:id/advisors/...`) keeps its prefix.
 */
export const opportunitiesNavItems = (paths: AdvisorsPaths): OpportunitiesNavItem[] => [
  {
    key: 'overview',
    title: 'Overview',
    description: 'Readiness checklist and a snapshot of everything waiting on you.',
    href: paths.opportunities,
    icon: LuGauge,
  },
  {
    key: 'invites',
    title: 'Board invites',
    description: 'Founders who invited you to a seat. Accept or decline here.',
    href: paths.opportunityInvites,
    icon: LuMailOpen,
    countKey: 'invited',
    palette: 'orange',
  },
  {
    key: 'applications',
    title: 'Board applications',
    description: 'Open seats you applied to. Waiting on the founder to accept or decline.',
    href: paths.opportunityApplications,
    icon: LuSend,
    countKey: 'applied',
    palette: 'blue',
  },
  {
    key: 'matches',
    title: 'Matched seats',
    description: 'Open board seats whose search ranked you as a fit.',
    href: paths.opportunityMatches,
    icon: LuTarget,
    countKey: 'matched',
    palette: 'green',
  },
  {
    key: 'engagements',
    title: 'Active engagements',
    description: 'Boards you already sit on, with a jump into each conversation.',
    href: paths.opportunityEngagements,
    icon: LuBriefcase,
    countKey: 'active',
    palette: 'blue',
  },
]
